import { Component, OnInit } from '@angular/core';
import { DEFAULT_HEADER_HEIGHT } from '@core/components/header/header.model';
import { takeUntil } from 'rxjs/operators';
import { NotificationsCenterService } from '@core/services/notifications-center.service';
import { UnsubscribeService } from '@core/services/unsubscribe.service';

@Component({
  selector: 'gcc-admin',
  template: `
    <div
      class="admin-content"
      [ngStyle]="{
        top: notificationsAndHeaderHeight + 'px',
        height: 'calc(100% - ' + notificationsAndHeaderHeight + 'px)'
      }"
    >
      <router-outlet></router-outlet>
    </div>
  `,
  styleUrls: ['./admin.component.scss'],
  standalone: false
})
export class AdminComponent implements OnInit {
  public notificationsAndHeaderHeight = DEFAULT_HEADER_HEIGHT;

  constructor(
    private notificationCenterService: NotificationsCenterService,
    private unsubscribe$: UnsubscribeService
  ) {}

  public ngOnInit() {
    this.notificationCenterService.notificationsAndHeaderHeight$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(height => {
        this.notificationsAndHeaderHeight = height;
      });
  }
}
